import { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';

const useSignalRWebSocket = (hubUrl: string, onNotificationReceived: (message: any) => void): any => {

  const [wsConnection, setWsConnection] = useState<signalR.HubConnection | null>(null);

  useEffect((): any => {
    // Stop the existing connection if any
    if (wsConnection) {
      wsConnection.stop();
    }
    // Create a SignalR connection
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    // Start the connection
    const startConnection = async (): Promise<void> => {
      try {
        await connection.start().then((): void => {
          setWsConnection(connection);
        }).catch((err: any): void => {
          console.error(`Error connecting SignalR: ${err}`);
        });

        // Handle the "NotificationReceived" event
        connection.on('NotificationReceived', (message: any): any => {
          if (onNotificationReceived) {
            onNotificationReceived(message);
          }
        }); // TODO: Create listeners like this for all the required events
      } catch (err) {
        console.error(`Error starting SignalR connection: ${err}`);
      }
    };

    if (process.env.REACT_APP_IS_NOTIFICATIONS_ENABLED === 'true' && localStorage.getItem('isNotificationEnabled') === 'true') {
      startConnection();
    }

    return (): void => {
      connection.stop();
    };
  }, [hubUrl, localStorage.getItem('isNotificationEnabled')]);

  const sendMessage = (message?: string): any => {
    if (wsConnection && wsConnection.state === signalR.HubConnectionState.Connected) {
      // Send a message to the server
      wsConnection.invoke('SendTestMessage'); // TODO: Replace 'SendTestMessage' with the actual method name
    }
  };

  return { sendMessage };
};

export default useSignalRWebSocket;
